import React from "react";

const hasExistingQueryParam = (url: string) => url.indexOf("?") > -1;

const getQueryParamDelimiter = (url: string) => (hasExistingQueryParam(url) ? "&" : "?");

const generateSrcSet = (srcSetSizes: number[], srcUrl: string) => {
    const generateSrcSetString = (srcSetSize: number) => {
        const parameterDelimiter = getQueryParamDelimiter(srcUrl);
        const srcSetSizeHighDensity = Math.round(srcSetSize * 1.5);

        return `
            ${srcUrl}${parameterDelimiter}w=${srcSetSize} ${srcSetSize}w,
            ${srcUrl}${parameterDelimiter}w=${srcSetSizeHighDensity} ${srcSetSizeHighDensity}w
        `;
    };

    return srcSetSizes.map(generateSrcSetString).join(", ");
};

interface ResponsiveImageProps
    extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    srcUrl: string;
    defaultSize: number;
    srcSetSizes: number[];
    role?: string;
}

const ResponsiveImage = (props: ResponsiveImageProps) => {
    const { srcUrl, defaultSize, srcSetSizes, role, ...rest } = props;
    const src = `${srcUrl}${getQueryParamDelimiter(srcUrl)}w=${defaultSize}`;
    const srcSet = srcSetSizes ? generateSrcSet(srcSetSizes, srcUrl) : "";

    return <img src={src} srcSet={srcSet} loading="lazy" alt={props.alt} role={role} {...rest} />;
};

export default ResponsiveImage;
